export enum LocationAccessStatusEnum {
  NotDetermined = 'not determined',
  Authorized = 'authorized',
  Denied = 'denied',
  Unavailable = 'unavailable',
  NotApplicable = 'not-applicable',
}
